$(document).ready(function () {
  
  $(".feature_slider .product-grid").slick({
    centerMode: true,
    centerPadding: "100px",
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          centerPadding: "50px",
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 991,
        settings: {
          centerPadding: "40px",
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {          
          centerPadding: "40px",
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });

  $(".mobile_slider .note_lists").slick({
    infinite: false,
    centerMode: true,
    centerPadding: "50px",
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false
  });

  $(".slider-metafield").slick({
    dots: false,
    infinite: false,
    speed: 300,
    centerPadding: '40px',
    centerMode: true,
    focusOnSelect: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  
});

// Gift box PDP Start

document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".slide-card_reference");
  const selectedCardInput = document.getElementById("selected_card");
  const cardPersonalMessage = document.getElementById("card_personal_message");
  const cardBlank = document.getElementById("card_blank");
  const personalMessageForm = document.getElementById("personal-message-form");
  const addToCartButton = document.querySelector(
    ".product-form__submit[name='add']"
  );

  if(personalMessageForm != null){
  addToCartButton.type = "button";
  personalMessageForm.style.display = "none"; 

  cardPersonalMessage.addEventListener("change", function () {
    personalMessageForm.style.display = "block";
  });

  cardBlank.addEventListener("change", function () {
    personalMessageForm.style.display = "none";
  });

  slides.forEach((slide) => {
    slide.addEventListener("click", function () {
      slides.forEach((slide) => slide.classList.remove("active"));
      this.classList.add("active");

      const cardId = this.querySelector(".data-card-id").innerText;
      selectedCardInput.value = cardId;

      addToCartButton.type = "submit";
    });
  });

  addToCartButton.addEventListener("click", function () {
    if (!selectedCardInput.value) {
      alert("Please select an image before adding to cart.");
    } else {
    }
  });
}
});

// Gift box PDP End